import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute(
  '/_secured/company-profile/naming-convention/new',
)({
  validateSearch: z.object({
    copyFrom: z.string().optional(),
  }),
});
